var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isFetchBaseQueryError } from '../../application/common/helpers/query-helpers';
import { useLazyGetCurrentUserQuery, useLazyGetTokenQuery } from '../../application/features/auth/auth-api';
import { signalRService } from '../../application/features/common/signalR-service';
import AppRoutes from '../layout/AppRoutes';
var MonteurAuthentication = function () {
    var navigate = useNavigate();
    var _a = __read(useState(false), 2), loginAssured = _a[0], setLoginAssured = _a[1];
    var _b = __read(useLazyGetCurrentUserQuery(), 1), getCurrentUser = _b[0];
    var _c = __read(useLazyGetTokenQuery(), 1), login = _c[0];
    useEffect(function () {
        var subscribeToPermissionsUpdate = function () {
            signalRService.initializeConnection();
            signalRService.subscribeToEvent('ReceivePermissionsUpdatedNotification', function () {
                return authorizeUser();
            });
        };
        var authorizeUser = function () { return __awaiter(void 0, void 0, void 0, function () {
            var error_1, apiError, error_2, apiError_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 8]);
                        return [4 /*yield*/, getCurrentUser().unwrap()];
                    case 1:
                        _a.sent();
                        subscribeToPermissionsUpdate();
                        setLoginAssured(true);
                        return [3 /*break*/, 8];
                    case 2:
                        error_1 = _a.sent();
                        if (!isFetchBaseQueryError(error_1)) return [3 /*break*/, 7];
                        apiError = error_1;
                        if (!(apiError.status === 401)) return [3 /*break*/, 7];
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, 6, 7]);
                        return [4 /*yield*/, login().unwrap()];
                    case 4:
                        _a.sent();
                        subscribeToPermissionsUpdate();
                        return [3 /*break*/, 7];
                    case 5:
                        error_2 = _a.sent();
                        if (isFetchBaseQueryError(error_2)) {
                            apiError_1 = error_2;
                            if (apiError_1.status === 401) {
                                navigate('unauthorized');
                            }
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        setLoginAssured(true);
                        return [7 /*endfinally*/];
                    case 7: return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        authorizeUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!loginAssured)
        return _jsx(_Fragment, {});
    return _jsx(AppRoutes, {});
};
export default MonteurAuthentication;
